const pro = {
  path: 'https://api.pinkuaikuai.cn'
}
export default pro
